import React, {
    Component,
    Fragment,
} from 'react'

import classnames from 'classnames'
import SportSelection from '../../admin/components/shared/sport-selection/sport-selection'
import AddSport from '../../admin/components/shared/addSport'
import Button from '../../front/components/shared/sn-button'
import {
    setOnBoardingStepAction,
    setUserSportAction,
    setUserSportObjectAction,
} from '../../admin/actions/on-boarding'
import {
    i18n,
    withConnectWrapper,
} from '../../validator'
import inOnBoarding, {
    ON_BOARDING_STEP_SPORT,
    ON_BOARDING_STEP_RELATIONSHIP,
} from './hoc'
import { SPORT_OTHERS_ID } from '../../consts'

import {
    deleteSport,
    storeSports,
} from './actions'

@i18n()
@inOnBoarding(ON_BOARDING_STEP_SPORT)
class SportOnboarding extends Component {
    state = {
        addSportModal: false,
        addedNewSport: false,
    }

    /**
     * Delete user sport from state
     *
     * @return {Promise}
     */
    deleteUserSport = sportId => {
        const { user } = this.props

        const userSportId = user?.sports?.data?.find?.(userSport => userSport.sport_id === sportId) || null

        if (!userSportId) {
            return new Promise(resolve => resolve())
        }

        return deleteSport(userSportId.id, user.slug)
    }

    /**
     * Go to next step
     */
    gotoNextStep = () => {
        const {
            userData,
            user,
        } = this.props

        const sportToSave = userData.sport.map(dataSport => dataSport.value)[0]

        return storeSports([sportToSave], user.slug)
            .then(({ data }) => {
                const userSport = data.data.find(dataSport => dataSport.sport_id === sportToSave)
                setUserSportObjectAction(userSport)
            })
            .then(() => setOnBoardingStepAction(ON_BOARDING_STEP_RELATIONSHIP))
    }

    /**
     * Display add sport modal
     */
    addSportToggleModal = () => {
        this.setState({ addSportModal: !this.state.addSportModal })
    }

    /**
     * Update selected sport after choosing one
     * @param {Array} selectedSports
     */
    updateSelectedSports = selectedSports => {
        if (selectedSports && selectedSports.length === 0) {
            setUserSportAction(null)
            this.setState({ addedNewSport: false })
        } else {
            setUserSportAction(selectedSports)
        }
    }

    /**
     * Convert fetched sports from API to sports used in SportSelection component
     * @returns {null|*}
     */
    getMappedSports = () => {
        const { fetchSports } = this.props

        if (fetchSports) {
            return fetchSports.map(sport => ({
                value: sport.id,
                label: sport.name,
            }))
        }

        return null
    }

    /**
     * Get and return other sport if founded else null
     * @returns {null|*}
     */
    getOtherSport = () => {
        const mappedSports = this.getMappedSports()
        if (!mappedSports) {
            return null
        }

        return mappedSports.find(sport => sport.value === SPORT_OTHERS_ID)
    }

    /**
     * Update added new sport in component state, if user has no selected another sport
     */
    updateAddedNewSportIfNotSelected = () => {
        const { userData } = this.props
        if (userData.sport) {
            return
        }

        this.setState({ addedNewSport: true })
    }

    /**
     * Only reload the window location, if we are not on the sportprofile subpage
     */
    handleNeedToRefreshPage = () => {
        if (window.location.href.includes('sportprofile')) {
            window.location.href = "/"
            return
        }
        window.location.reload()
    }

    render = () => {
        const {
            t,
            userData,
            sportId,
            editSport,
            user,
        } = this.props

        const {
            addSportModal,
            addedNewSport,
        } = this.state

        const mappedSports = this.getMappedSports()

        const editedSport = user?.sports?.data?.filter?.(sport => sport.sport_id === sportId)

        return (
            <Fragment>
                <div className="d-flex flex-column">
                    <span className="text-color-gray-dark-1 font-weight-bold font-size-xl">
                        {t('mySport')}
                    </span>
                    <span className="text-color-gray-dark-1 font-size-md mb-3">
                        {t('chooseYourFavouriteSport')}
                    </span>
                    {mappedSports && !addedNewSport &&
                        <SportSelection
                            singleSport
                            centered
                            sports={mappedSports}
                            addSportHandle={this.addSportToggleModal}
                            updateSelectedSports={this.updateSelectedSports}
                            selectedSports={sportId ? editedSport : (userData.sport || [])}
                            inputContainerClassName="col-12 col-md-7"
                        />
                    }
                    {mappedSports && addedNewSport &&
                        <SportSelection
                            singleSport
                            centered
                            sports={mappedSports}
                            addSportHandle={this.addSportToggleModal}
                            updateSelectedSports={this.updateSelectedSports}
                            preselectedSport={this.getOtherSport()}
                            selectedSports={userData.sport || []}
                            inputContainerClassName="col-12 col-md-7"
                        />
                    }
                    <div className="mt-4">
                        {editSport &&
                            <Button
                                className={classnames({
                                    'btn btn-color-gray-light-2 btn-circle float-left': true,
                                })}
                                onClick={() => {
                                    window.swconfirm({
                                        type: 'info',
                                        confirmBtnBsStyle: 'success',
                                        title: t('onBoarding.removeSportModal.text'),
                                        onConfirm: () => this.deleteUserSport(sportId),
                                        afterConfirm: () => this.handleNeedToRefreshPage(),
                                    })
                                }}
                            >
                                {t('delete')}
                            </Button>
                        }
                        <Button
                            className={classnames({
                                'btn btn-color-brand btn-circle float-right': true,
                                'btn-disabled': !userData.sport,
                            })}
                            onClick={this.gotoNextStep}
                            disabled={!userData.sport}
                        >
                            {t('nextStep')}
                        </Button>
                    </div>
                </div>
                {addSportModal &&
                    <AddSport
                        toggleModal={this.addSportToggleModal}
                        onSportSubmitted={this.updateAddedNewSportIfNotSelected}
                    />
                }
            </Fragment>
        )
    }
}

export default withConnectWrapper(state => ({
    userTokens: state.auth.tokens,
    userStoreTokens: state.auth.storeTokens,
    userData: state.onBoarding.userData,
    fetchSports: state.onBoarding.sports,
}))(SportOnboarding)
